import React from 'react';
import { Link } from 'react-router-dom';

const blogs = [
    {
        id: 1,
        title: 'Navigating the Future of Remote Work',
        category: 'Career Advice',
        image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&w=800&q=80',
        date: 'March 15, 2024',
        excerpt: 'Remote work is no longer just a trend; it is the new standard. Learn how to thrive in a distributed team environment.'
    },
    {
        id: 2,
        title: 'Top Skills for Tech Recruitment in 2024',
        category: 'Hiring Trends',
        image: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?auto=format&fit=crop&w=800&q=80',
        date: 'March 12, 2024',
        excerpt: 'Stay ahead of the curve by mastering the most in-demand technical and soft skills for the upcoming year.'
    },
    {
        id: 3,
        title: 'Building Inclusive Workplace Cultures',
        category: 'Management',
        image: 'https://images.unsplash.com/photo-1522202176988-66273c2fd55f?auto=format&fit=crop&w=800&q=80',
        date: 'March 10, 2024',
        excerpt: 'Diversity and inclusion are key to innovation. Discover strategies for creating a more equitable workplace.'
    },
    {
        id: 4,
        title: 'The Rise of AI in Human Capital Management',
        category: 'Technology',
        image: 'https://images.unsplash.com/photo-1485827404703-89b55fcc595e?auto=format&fit=crop&w=800&q=80',
        date: 'March 05, 2024',
        excerpt: 'Artificial intelligence is transforming how we find, hire, and manage talent. Explore the latest AI tools and trends.'
    },
    {
        id: 5,
        title: 'Interview Preparation: A Strategic Approach',
        category: 'Career Advice',
        image: 'https://images.unsplash.com/photo-1549923746-c502d488b3ea?auto=format&fit=crop&w=800&q=80',
        date: 'March 02, 2024',
        excerpt: 'Master the art of interviewing with our comprehensive guide to preparation, communication, and follow-up.'
    }
];

export default function Discover() {
    return (
        <div className="bg-light min-h-screen pt-20">
            <section className="bg-secondary py-20 text-white relative overflow-hidden">
                <div className="absolute top-0 right-0 w-1/3 h-full bg-primary/10 -skew-x-12"></div>
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
                    <h1 className="text-4xl md:text-6xl font-bold mb-6">Discover Insights</h1>
                    <p className="text-xl text-gray-300 max-w-2xl">
                        Expert perspectives on careers, recruitment, and the future of workplace culture.
                    </p>
                </div>
            </section>

            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
                    {blogs.map((blog) => (
                        <Link
                            key={blog.id}
                            to={`/discover/${blog.id}`}
                            className="bg-white rounded-[32px] overflow-hidden shadow-sm hover:shadow-xl transition-all duration-500 group border border-gray-100 hover:-translate-y-2"
                        >
                            <div className="relative h-64 overflow-hidden">
                                <img
                                    src={blog.image}
                                    alt={blog.title}
                                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                                />
                                <div className="absolute top-6 left-6 bg-white/90 backdrop-blur-sm px-4 py-1.5 rounded-full text-xs font-bold text-primary shadow-sm">
                                    {blog.category}
                                </div>
                            </div>
                            <div className="p-8">
                                <div className="flex items-center gap-3 text-sm text-gray-400 mb-4">
                                    <span>{blog.date}</span>
                                    <span className="w-1 h-1 rounded-full bg-gray-300"></span>
                                    <span>5 min read</span>
                                </div>
                                <h3 className="text-2xl font-bold text-dark mb-4 group-hover:text-primary transition-colors leading-tight">
                                    {blog.title}
                                </h3>
                                <p className="text-body text-sm line-clamp-3 mb-6 leading-relaxed">
                                    {blog.excerpt}
                                </p>
                                <div className="flex items-center font-bold text-primary text-sm gap-2">
                                    Read Article <i className="fas fa-arrow-right transition-transform group-hover:translate-x-1"></i>
                                </div>
                            </div>
                        </Link>
                    ))}
                </div>
            </div>
        </div>
    );
}
